import { IModel, IAttribute, IViolation } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';
import { SapOpenHubTableDataset } from '../../dataset/sap-open-hub-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.sapOpenHub.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(SapOpenHubTableDataset)
        ]
    }
})
export class SapOpenHubCopySource extends TabularCopySource {
    public static readonly MODEL: IModel;
    public static readonly EXCLUDE_LAST_REQUEST: IAttribute;
    public static readonly BASE_REQUEST_ID: IAttribute;
    public static readonly CUSTOM_FUNCTION_MODULE: IAttribute;
    public static readonly SAP_COLUMN_DELIMITER: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_BaseRequestId,
        association: 'BASE_REQUEST_ID',
        templatable: true
    })
    public baseRequestId?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_ExcludeLastRequest,
        association: 'EXCLUDE_LAST_REQUEST',
        templatable: true
    })
    public excludeLastRequest?: boolean = false;

    @Metamodel.attribute({
        templatable: true,
        association: 'CUSTOM_FUNCTION_MODULE',
        display: stringResources.ModelName_CustomRfcReadTableFunctionModule
    })
    public customRfcReadTableFunctionModule?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'SAP_COLUMN_DELIMITER',
        display: stringResources.ModelName_ColumnDelimiter,
        constraint: {
            validator: SapOpenHubCopySource.validateSapDataColumnDelimiter
        }
    })
    public sapDataColumnDelimiter?: string;

    public isV2: boolean = false;

    public static validateSapDataColumnDelimiter(copySource?: SapOpenHubCopySource): IViolation[] {
        const violations: IViolation[] = [];
        if (!stringIsNullOrEmpty(copySource.sapDataColumnDelimiter) && !(/^(\\u([0-9a-f]){4}|[^])$/.test(copySource.sapDataColumnDelimiter))) {
            violations.push({
                message: () => stringResources.Sap_ColumnDelimiter_ValidationError
            });
        }
        return violations;
    }

}
